'use client';


import type { Breakpoint } from '@mui/material/styles';

import { usePathname } from 'src/routes/hooks';

import { AnalyticsProvider } from 'src/lib/analytics/react'

import { useAuthContext } from 'src/auth/hooks';

import { Header } from './header';
import { HomeFooter } from './footer';
import { MainSection } from '../core/main-section';
import { LayoutSection } from '../core/layout-section';

import type { MainSectionProps } from '../core/main-section';
import type { LayoutSectionProps } from '../core/layout-section';

// ----------------------------------------------------------------------

type MainLayoutProps = LayoutSectionProps & {
  layoutQuery?: Breakpoint;
  slotProps?: {
    header?: Record<string, unknown>;
    main?: MainSectionProps;
  };
};

export function MainLayout({ sx, cssVars, children, slotProps, layoutQuery = 'md' }: MainLayoutProps) {
  const pathname = usePathname();
  const { user, loading: authLoading } = useAuthContext();

  console.log('🔍 [MainLayout] user:', user);

  // const { value: open, onFalse: onClose, onTrue: onOpen } = useBoolean();

  // isHomePage 는 JS 시절부터 안 쓰던 값 — 삭제는 이 배치 계약 밖 (rename+타입만)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const isHomePage = pathname === '/';

  // const renderHeader = () => {
  //   const headerSlots = {
  //     topArea: (
  //       <Alert severity="info" sx={{ display: 'none', borderRadius: 0 }}>
  //         This is an info Alert.
  //       </Alert>
  //     ),
  //     leftArea: (
  //       <>
  //         {/** @slot Nav mobile */}
  //         <MenuButton
  //           onClick={onOpen}
  //           sx={(theme) => ({
  //             mr: 1,
  //             ml: -1,
  //             [theme.breakpoints.up(layoutQuery)]: { display: 'none' },
  //           })}
  //         />
  //         <NavMobile data={navData} open={open} onClose={onClose} />

  //         {/** @slot Logo */}
  //         <Logo />
  //       </>
  //     ),
  //     rightArea: (
  //       <>
  //         {/** @slot Nav desktop */}
  //         <NavDesktop
  //           data={navData}
  //           sx={(theme) => ({
  //             display: 'none',
  //             [theme.breakpoints.up(layoutQuery)]: { mr: 2.5, display: 'flex' },
  //           })}
  //         />

  //         <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 1.5 } }}>
  //           {/** @slot Settings button */}
  //           <SettingsButton />

  //           {/** @slot Sign in button */}
  //           <SignInButton />

  //           {/** @slot Purchase button */}
  //           <Button
  //             variant="contained"
  //             rel="noopener"
  //             target="_blank"
  //             href={paths.minimalStore}
  //             sx={(theme) => ({
  //               display: 'none',
  //               [theme.breakpoints.up(layoutQuery)]: { display: 'inline-flex' },
  //             })}
  //           >
  //             Purchase
  //           </Button>
  //         </Box>
  //       </>
  //     ),
  //   };

  //   return (
  //     <Header
  //       layoutQuery={layoutQuery}
  //       {...slotProps?.header}
  //       slots={{ ...headerSlots, ...slotProps?.header?.slots }}
  //       slotProps={slotProps?.header?.slotProps}
  //       sx={slotProps?.header?.sx}
  //     />
  //   );
  // };

  const renderHeader = () => (
    <Header layoutQuery={layoutQuery} user={user} loading={authLoading} />
  );

  const renderFooter = () => 
    // if (isHomePage) {
    //   return <HomeFooter />;
    // } else {
    //   return <Footer />;
    // }
     <HomeFooter />
  ;

  const renderMain = () => <MainSection {...slotProps?.main}>{children}</MainSection>;

  return (
    <LayoutSection
      /** **************************************
       * @Header
       *************************************** */
      headerSection={renderHeader()}
      /** **************************************
       * @Footer
       *************************************** */
      footerSection={renderFooter()}
      /** **************************************
       * @Styles
       *************************************** */
      cssVars={cssVars}
      sx={sx}
    >
      <AnalyticsProvider />
      {renderMain()}
    </LayoutSection>
  );
}
